import {Injectable} from '@angular/core';

export interface PackageTypeName {
  param: string
}

export interface PackageType {
  single: PackageTypeName;
  teamPlay: PackageTypeName;
  bundle: PackageTypeName;
}

@Injectable()
export class PackageService {

  static types: PackageType = {
    single: {
      param: 'single-lottery'
    },
    teamPlay: {
      param: 'team-play'
    },
    bundle: {
      param: 'bundle'
    }
  };

}
